module.exports = __webpack_public_path__ + "img/icon_check.29d89797.svg";